module.exports = __webpack_public_path__ + "media/images/thumbnails/thumb5-39470b7ef97178090bd9f6ee478a5ea5.jpg";